/** Durable-play failures. Every message is written to be shown to a player as-is. */

export class SaveCorruptError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'SaveCorruptError';
  }
}

/** Another writer holds this chronology. `retryAtMs` is set only when the holder's lease lapses
 * on this clock, so a caller can wait for the old window instead of refusing the player. */
export class WriterConflictError extends Error {
  readonly retryAtMs: number | null;
  readonly holderId: string | null;
  constructor(message: string, conflict: Readonly<{ retryAtMs?: number; holderId?: string }> = {}) {
    super(message);
    this.name = 'WriterConflictError';
    this.retryAtMs = conflict.retryAtMs ?? null;
    this.holderId = conflict.holderId ?? null;
  }
}

export class StaleWriterError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'StaleWriterError';
  }
}

/** Durable storage refused a write: play pauses at a known tick instead of advancing on unsaved state. */
export class StorageUnavailableError extends Error {
  readonly pausedAtTick: number;
  readonly detail: string;
  constructor(pausedAtTick: number, detail: string) {
    super(`Progress is paused at tick ${pausedAtTick}: ${detail}`);
    this.name = 'StorageUnavailableError';
    this.pausedAtTick = pausedAtTick;
    this.detail = detail;
  }
}
